module.exports = require("@products-react-components/utils/lib/ErrorBoundary");